import page from '../helpers/page';
import selectors from "../globals/selectors";
import accordion from '../components/accordion/index';

page(() => {
    const accordionElsReq = document.querySelectorAll(
        selectors.accordionNew.element
    );
    accordionElsReq.forEach((el) => accordion(el));
})